function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Input from '../input/Input';
import { ICON_CURRENCY_EUR } from '../../icons';
const formatter = new Intl.NumberFormat('it-IT');
export const PriceField = _ref => {
  let {
    name,
    value,
    'aria-label': ariaLabel,
    onChange,
    ...rest
  } = _ref;
  const [formattedValue, setFormattedValue] = React.useState();
  const getFormattedValue = React.useCallback(inputValue => inputValue ? formatter.format(parseInt(inputValue, 10)) : inputValue, []);
  React.useEffect(() => {
    const tempFormattedValue = getFormattedValue(value);
    if (tempFormattedValue !== formattedValue) {
      setFormattedValue(getFormattedValue(value));
    }
  }, [formattedValue, getFormattedValue, value]);
  const onInternalChange = React.useCallback(e => {
    const numericMatch = e.target.value.match(/\d+/g);
    e.target.value = numericMatch ? numericMatch.join('') : '';
    e.target.name = name || '';
    if (onChange) {
      onChange(e);
    }
  }, [name, onChange]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, _extends({
    icon: ICON_CURRENCY_EUR
  }, rest, {
    "aria-label": ariaLabel,
    type: "tel",
    pattern: "[0-9]*",
    value: formattedValue || '',
    onChange: onInternalChange,
    min: 0
  })), /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
    "aria-label": `${ariaLabel} (hidden)`,
    type: "hidden",
    name: name,
    value: value,
    onChange: () => {}
  })));
};
export default PriceField;
//# sourceMappingURL=PriceField.js.map